import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core';

import { appConfigSelector } from 'reducers/app.reducer';
import { ICustomTheme } from 'interfaces';
import { LinkWithUIGuidelines } from 'component-library/atoms/LinkWithUIGuidelines';
import { BasicTextWithUIGuidelines } from 'component-library/atoms/BasicTextWithUIGuidelines';

export default function CGULabel() {
  const { programUrl, userConditionsPath } = useSelector(appConfigSelector);
  const theme: ICustomTheme = useTheme();
  const { t } = useTranslation();

  return (
    <>
      <BasicTextWithUIGuidelines
        text={t('auth.signup.terms')}
        margin={`${theme.spacing(1)}px ${theme.spacing(1)}px 0px 0px`}
      />
      <LinkWithUIGuidelines
        color={theme.colors.paletteFromBO.main}
        fontWeight="bold"
        url={`${programUrl}${userConditionsPath}`}
        textLink={t('auth.signup.cgu')}
        isInternalLink={false}
        withUnderline
      />
      {'*'}
    </>
  );
}
